module.exports = __webpack_public_path__ + "img/background-login.abfe19b2.webp";